var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPriceCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91683 22.4541V20.6208H0.333496V16.9541H9.50016V13.2874H2.16683C1.64738 13.2874 1.21197 13.1117 0.860579 12.7604C0.509191 12.409 0.333496 11.9735 0.333496 11.4541V4.12077C0.333496 3.60132 0.509191 3.16591 0.860579 2.81452C1.21197 2.46313 1.64738 2.28743 2.16683 2.28743H4.91683V0.454102H8.5835V2.28743H13.1668V5.9541H4.00016V9.62077H11.3335C11.8529 9.62077 12.2884 9.79646 12.6397 10.1479C12.9911 10.4992 13.1668 10.9347 13.1668 11.4541V18.7874C13.1668 19.3069 12.9911 19.7423 12.6397 20.0937C12.2884 20.4451 11.8529 20.6208 11.3335 20.6208H8.5835V22.4541H4.91683ZM18.5752 33.4541L10.7835 25.6624L13.3502 23.0958L18.5752 28.3208L28.9335 17.9624L31.5002 20.5291L18.5752 33.4541Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriceCheck);
export default __webpack_public_path__ + "static/media/icon_price_check.039b6eee95ee60fbdcb48c8d70ff8712.svg";
export { ForwardRef as ReactComponent };